import { GlobalContext } from '../context/GlobalState';
import { useContext } from 'react';
import { Heart } from './Heart';
import { ApplyButton } from './ApplyButton';
import { getLocalAvatar, resolveAvatarUrl } from '../utils/avatarUtils';

export const MusicianCard = ({ musician }) => {
  const { isLoggedIn } = useContext(GlobalContext);
  const {
    _id,
    firstName,
    lastName,
    instrument,
    genre,
    description,
    image_url,
    uploadedImageId,
  } = musician;

  return (
    <li className='card card-musician'>
      {isLoggedIn && (
        <div className='card-favorite'>
          <Heart cardId={_id} />
        </div>
      )}
      <img
        src={resolveAvatarUrl(
          image_url,
          `${firstName} ${lastName}`,
          uploadedImageId,
        )}
        alt='musician'
        loading='lazy'
        decoding='async'
        onError={e => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = getLocalAvatar(`${firstName} ${lastName}`);
        }}
      />
      <div className='card-title'>
        {firstName} {lastName}
      </div>
      <div className='card-divider' />
      <div className='card-meta'>Genre: {genre}</div>
      <div className='card-section'>
        <span className='card-section-label'>Instrument</span>
        {instrument.map(element => (
          <span className='chip instrument' key={element}>
            {element}
          </span>
        ))}
      </div>
      <div className='card-description'>{description}</div>
      {isLoggedIn && (
        <div className='container-card-bottom'>
          <ApplyButton card={musician} />
        </div>
      )}
    </li>
  );
};
